// Brand and nav are now inside TopBarMenu. This component is kept as a no-op
// so all existing page imports continue to compile without changes.
export const TopLeftComponent = () => null;
